// extracted by mini-css-extract-plugin
export default {"recos":"G6-z","productCardOverride":"H6-z","rowHasBadge":"I6-z"};